import React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Typography, Box } from "@mui/material";

function CustomAccordion({ sections, height }) {
  return (
    <>
      {sections.map((section, index) => (
        <Accordion key={index}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography  sx={{ color: section.labelColor,fontWeight: 'bold'}}>{section.label}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {/* Wrap content in a Box with overflow styling */}
            <Box
              sx={{
                maxHeight: height,
                overflow: "auto",
                width: "100%",
                padding:"3px",
             
                "&::-webkit-scrollbar": {
                  width: "4px", // Width of the scrollbar
                  backgroundColor: "#f5f5f5", // Color of the scrollbar track
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#888", // Color of the scrollbar thumb
                  borderRadius: "4px", // Rounded corners of the scrollbar thumb
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  backgroundColor: "#555", // Color of the scrollbar thumb on hover
                },
              }}
            >
              <Typography>{section.content}</Typography>
            </Box>
          </AccordionDetails>
        </Accordion>
      ))}
    </>
  );
}

export default CustomAccordion;
